import * as dotenv from "dotenv";
dotenv.config();

import * as support from "./support";

support.init();
